import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { AuthService } from 'src/app/core/_services/pages/auth.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  public resetPasswordForm: FormGroup;
  submitted:boolean= false;
  validationErrorMessage=APP_CONSTANT.VALIDATION;

  constructor(private authService: AuthService,private validationService: ValidationService,private toastr: ToastrService,private loader: NgxUiLoaderService, private service: PagesService ,private router: Router, private fb: FormBuilder, private storageService: LocalStorageProvider) {
    this.resetPasswordForm = this.createForm();
  }

  ngOnInit(): void {
  }

  createForm() {
    return this.fb.group({
      new:['', [Validators.required,Validators.pattern(AppConst.PASSWORD_PATTERN)]],
      confirm: ['', Validators.required]
    })
  }
  get f(){
    return this.resetPasswordForm.controls;
  }
  submitResetForm() {
    console.log(this.resetPasswordForm)
    let post = this.resetPasswordForm.value
    this.submitted = true;
    if(this.resetPasswordForm.valid){
      if (post.new !== post.confirm) {
        this.toastr.error('New Password and Confirm Password should be same');
        return false;
      }
      let data = {
        email:this.authService.adminEmail,
        password: post.new
      }
      this.resetPassword(data);
    }
    return true;
  }
  resetPassword(data:any){
    this.service.post(data,`${API_ROUTES.ACCOUNT.resetPassword}`).pipe().subscribe((response: any) => {
      this.loader.start();
      if(response.status){
        this.authService.adminEmail = ''
        this.router.navigate([`${RouteConstant.PasswordUpdated}`])
      }else this.toastr.error(response.msg)
      this.loader.stop();
    })
  }

  cancel() {
    this.router.navigate([`${RouteConstant.Login}`])
  }
  passwordValidation(value:any){
    return this.validationService.passwordValidationMessage(value);
  }
}
